import { render, staticRenderFns } from "./Swagger.vue?vue&type=template&id=31b6dce4"
import script from "./Swagger.vue?vue&type=script&lang=ts"
export * from "./Swagger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports